module.exports = __webpack_public_path__ + "static/blog-1-4-625d7085ec1603a6fb54142a45993804.jpg";